import {
  CButton,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react';
import React, { useState } from 'react';
import adminApi from 'services/adminApi';

export default function AccountDefaultModal({
  isModalOpen,
  setIsModalOpen,
  userId,
  setUserList,
}) {
  const [defaultAccount, setDefaultAccount] = useState({
    username: 'admin@app.com',
    password: 'vnnic@123',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setDefaultAccount((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSave = async () => {
    const res = await adminApi({
      url: `/user/${userId}`,
      method: 'PUT',
      body: {
        email: defaultAccount.username,
        password: defaultAccount.password,
      },
    });

    const { isSuccess, message } = await res.json();

    if (!isSuccess) {
      alert(message);
      return;
    }

    setTimeout(() => {
      handleCancel();
    }, 10);

    setTimeout(() => {
      alert('User is updated successfully');

      const currentPath = window.location.pathname;
      if (currentPath === '/admin') {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        window.location.href = '/login';
      }

      if (currentPath === '/system/reset') {
        if (setUserList) {
          setUserList((prev) => {
            const updatedList = [...prev];
            if (updatedList.length > 0) {
              updatedList[0] = { ...updatedList[0], email: 'admin@app.com' };
            } else {
              updatedList.push({ email: 'admin@app.com' });
            }
            return updatedList;
          });
        }
      }
    }, 300);
  };

  return (
    <CModal visible={isModalOpen} onClose={handleCancel}>
      <CModalHeader>
        <CModalTitle>Default Account</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm>
          <CRow className="mb-3">
            <CCol>
              <CFormLabel htmlFor="modal-username">Default username</CFormLabel>
              <CFormInput
                type="text"
                id="modal-username"
                name="username"
                value={defaultAccount.username}
                onChange={handleChange}
                disabled
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol>
              <CFormLabel htmlFor="modal-password">Default password</CFormLabel>
              <CFormInput
                type="text"
                id="modal-password"
                name="password"
                value={defaultAccount.password}
                onChange={handleChange}
                disabled
              />
            </CCol>
          </CRow>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={handleCancel}>
          Cancel
        </CButton>
        <CButton color="primary" onClick={handleSave}>
          Reset
        </CButton>
      </CModalFooter>
    </CModal>
  );
}
